module.exports = __webpack_public_path__ + "static/media/niqueuenitetete.4dd61319.png";